import React from "react";
import { TextField, FormControl, FormLabel } from "@mui/material";

const TextInput = ({
  id,
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  helperText,
  type,
  options = {},
}) => {
  return (
    <FormControl fullWidth required={required} sx={{ mb: 2 }}>
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <TextField
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        helperText={helperText}
        type={type}
        {...options}
      />
    </FormControl>
  );
};

export default TextInput;
